/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutAIConfigSandboxPathParams = NonNullable<operations['putAIConfigSandbox']['parameters']['path']>;

export type PutAIConfigSandboxRequestBody = OperationRequestBodyContent<operations['putAIConfigSandbox']>;

export interface Input extends PutAIConfigSandboxPathParams {
  apiVersion?: string;
  body: PutAIConfigSandboxRequestBody;
  header: NonNullable<operations['putAIConfigSandbox']['parameters']['header']>;
}

export async function putAIConfigSandbox(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/ai-configs/{configKey}/sandbox', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
